import React from 'react';

import { TimeSettings } from '@vyce/core/src/views/time/TimeSettings';
import { NoAccess } from '@vyce/core/src/components';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { TIME_INTERFACE_PERMISSIONS } from '@vyce/core/src/types';

import { useTypedSelector } from '../../hooks';

export const EmployerTimeSettings: React.FC = () => {
  const { selectedCompany, selectedCompanyAppData } = useTypedSelector(state => state.helper);
  const { can } = usePermissions();

  // The tab itself is filtered out without this right; this covers a deep link.
  if (!can(TIME_INTERFACE_PERMISSIONS.MANAGE_TIME_SETTINGS)) {
    return <NoAccess title="You don’t have access to Time settings" />;
  }

  return <TimeSettings companyId={selectedCompany?.uuid} locations={selectedCompanyAppData?.locations} />;
};
